import { Dossier, Fitter } from 'functions/commons';

export interface DossierLastStepFormBottomSheetData {
  currentDossier: Dossier;
  currentFitter: Fitter;
  isCallBack: boolean;
}
